














































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { required } from 'vuelidate/lib/validators';

@Component({
  components: {
    ...UUIFComponent,
  },
  validations: {
    machineId: { required },
  },
})
export default class Scrutinizer extends SwExtendedVue {
  @Prop()
  showScrutinizerDialog: boolean;
  @Prop()
  scrutinizerHelpText: string;
  submitted: boolean = false;
  errorMessage: string = '';
  machineId: string = '';
  closeDialog() {
    this.$emit('closeDialog');
  }
  validateForm() {
    this.submitted = true;
    this.errorMessage = '';
    this.$v.$touch();
    if (this.$v.$invalid) {
    } else {
      this.$emit('closeDialog', { scrutizerId: this.machineId });
    }
  }
}
